/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Knowledgelab1Inputs */

const zh_sidebar_knowledgelab1 = /** @type {(inputs: Sidebar_Knowledgelab1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学习中心`)
};

const en_sidebar_knowledgelab1 = /** @type {(inputs: Sidebar_Knowledgelab1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learning Center`)
};

const es_sidebar_knowledgelab1 = /** @type {(inputs: Sidebar_Knowledgelab1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de Aprendizaje`)
};

/**
* | output |
* | --- |
* | "Learning Center" |
*
* @param {Sidebar_Knowledgelab1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const sidebar_knowledgelab1 = /** @type {((inputs?: Sidebar_Knowledgelab1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Knowledgelab1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_sidebar_knowledgelab1(inputs)
	if (locale === "en") return en_sidebar_knowledgelab1(inputs)
	return es_sidebar_knowledgelab1(inputs)
});
export { sidebar_knowledgelab1 as "sidebar_knowledgeLab" }